import React, { useState } from "react";
import "../css/paymentmodal.css";
import UserHeader from "./UserHeader";
import PaymentSummery from "./PaymentSummery";
import AppointmentSuccess from "./AppointmentSuccess";
import { closeSvg } from "../assets/svg";
function PaymentModal({ showPaymentModal, toggleModal, handleBookAppointment, isAppointmentSuccessful }) {

    if (!showPaymentModal) {
        return null;
    }

    return (
        <div className="payment-modalOverlay">
            <div className="payment-modal">
                <div className="payment-modal-content">
                    <div className="payment-modal-header px-3">
                        <div className="f500-24px">Payment</div>
                        <div
                            type="button"
                            className="close"
                            onClick={toggleModal}
                        >
                            {closeSvg({})}
                        </div>
                    </div>
                    <div>
                        <UserHeader />
                        <hr />
                    </div>
                    {isAppointmentSuccessful ? (
                        <AppointmentSuccess />
                    ) : (
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="f600-18px text-center">
                                    Pay Now
                                </div>
                                <ul className="left-bar">
                                    <li className="f500-16px">
                                        All charges, registration fees etc,
                                        shall be levied as per standard Hospital
                                        Policy and shall be payable at the
                                        hospital billing desk
                                    </li>
                                    <li className="f500-16px">
                                        With Pay Now Facility, you have a
                                        hassle-free Option to make your payment
                                        Online
                                    </li>
                                </ul>
                                <div>
                                    <PaymentSummery />
                                    <div className="d-flex justify-content-center">
                                        <div
                                            className="payment-btn"
                                            onClick={() => {
                                                // setIsAppointmentSuccessful(true);
                                                handleBookAppointment();
                                            }}
                                        >
                                            Pay Now
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="f600-18px text-center">
                                    Pay Later
                                </div>
                                <ul className="right-bar">
                                    <li className="f500-16px">
                                        With Pay Now Facility, you have a
                                        hassle-free Option to make your payment
                                        Online
                                    </li>
                                    <li className="f500-16px">
                                        All charges, registration fees etc,
                                        shall be levied as per standard Hospital
                                        Policy and shall be payable at the
                                        hospital billing desk
                                    </li>
                                </ul>
                                <div>
                                    <PaymentSummery />
                                </div>
                                <div className="d-flex justify-content-center">
                                    <div
                                        className="payment-btn"
                                        onClick={() => {
                                            handleBookAppointment();
                                        }}
                                    >
                                        Pay Later
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="payment-footer">
                        <div className="f-title mb-2">Note :</div>
                        <ul className="f-text">
                            <li>
                                Please login to patient portal on for
                                Cancellation/ Reprint Receipt/ Diagnostic
                                Reports/ Appointment and other details
                            </li>
                            <li>
                                Please use your “UHID” as UserID and “Registered
                                Mobile No.” as password.
                            </li>
                            <li>
                                We request you to reach Hospital 30 min before
                                your scheduled appointment time for completing
                                your Vital Checks at Nursing station and any
                                other formalities, as may be required.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentModal;
